import type { Group } from "@dashboard/devices/types";

/**
 * Number of devices in the workspace. Every device sits directly in exactly one group, so the groups' own counts add
 * up to the workspace; the aggregated counts would count a subgroup's devices once more for each ancestor.
 */
export function countWorkspaceDevices(groups: Group[]): number {
    return groups.reduce((total, group) => total + (group.statistics?.own.deviceCount ?? 0), 0);
}
